import { SavannaTheme } from "../.internal/themes/SavannaTheme";
export default SavannaTheme;
